import {HTTP} from "./common";

export const ReportApi = {

    list(page) {
        return HTTP.get(`reports/?page=${page}&size=20`).then((response) => {
            return response.data;
        });
    },
    create(data) {
        return HTTP.post(`reports/download_file/`, data).then(response => {
            return response.data
        })
    },
    protected_report_download(data) {
        return HTTP.post(`reports/protected_report_download/`, data, {responseType: "blob"}).then(response => {
            return response
        })
    },
        weekly_report(data) {
        return HTTP.post(`reports/weekly_report/`, data).then(response => {
            return response.data
        })
    },


};


